import React from 'react'
import {
  presenceErrorClass,
} from 'servos/formValidations'

class ProfileInput extends React.Component {
  render() {
    const {
      errors,
      label,
      id,
      handleInput,
      value,
      className,
      placeholder,
    } = this.props

    return (
      <div className={ className }>
        <label>
          <span>{label}</span>
        </label>
        {this.props.children}
        <input
          id={id}
          className={`form-control ${presenceErrorClass(errors[id])}`}
          value={value}
          onChange={handleInput}
          placeholder={placeholder}
        />
        <div className="invalid-feedback">
          { errors[id] }
        </div>
      </div>
    )
  }
}

export default ProfileInput;
